import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavbarSearchCustomersDataService {

  toggleSearch = new Subject<void>()

  constructor() { }

}
